import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { ReadSelectField } from '@cli-types/next-adapter/generators.js'
export function collectReadSelectFields(
  fields: SchemaField[],
  path: string[] = []
): ReadSelectField[] {
  const matches = fields.flatMap((field) => {
    const currentPath = [...path, field.name]
    const matches: ReadSelectField[] = field.type === 'select' ? [{ field, path: currentPath }] : []
    if (field.fields) {
      matches.push(...collectReadSelectFields(field.fields, currentPath))
    }
    if (field.tabs) {
      for (const tab of field.tabs) {
        matches.push(...collectReadSelectFields(tab.fields ?? [], currentPath))
        if (tab.slot?.main?.fields) {
          matches.push(...collectReadSelectFields(tab.slot.main.fields, currentPath))
        }
        if (tab.slot?.sidebar?.fields) {
          matches.push(...collectReadSelectFields(tab.slot.sidebar.fields, currentPath))
        }
      }
    }
    return matches
  })
  const seen = new Set<string>()
  return matches.filter((match) => {
    const key = match.path.join('.')
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
